module.exports = __webpack_public_path__ + "img/tooltip_07-vallone-noya-29H-black.c06cb469.jpg";